import { render, staticRenderFns } from "./InputCKEditor.vue?vue&type=template&id=21679c7f"
import script from "./InputCKEditor.vue?vue&type=script&lang=js"
export * from "./InputCKEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports